import { render, staticRenderFns } from "./MessageRecipients.vue?vue&type=template&id=5fc9554c&"
import script from "./MessageRecipients.vue?vue&type=script&lang=js&"
export * from "./MessageRecipients.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports